// LF360-1852 — the description editor keeps its own instance, and with it the undo
// history. Reusing it for another task would let an admin undo their way into that
// task's content and save it here, so the key it is rebuilt by has to change with
// the task's identity — not with its text, which two tasks can easily share, and
// which is empty for most of them.
//
// `stamp` is what forces a rebuild for the same task and mode, once its media has
// been signed afresh.
export const descriptionEditorKey = (taskId, editMode, stamp) =>
  [
    "description",
    taskId || "new",
    editMode ? "edit" : "view",
    stamp === undefined || stamp === null ? "" : String(stamp),
  ]
    .filter((part) => part !== "")
    .join("-");

export default descriptionEditorKey;
